import React, { useEffect, useRef } from 'react';
import * as am5 from '@amcharts/amcharts5';
import * as am5percent from '@amcharts/amcharts5/percent';
import am5themes_Animated from '@amcharts/amcharts5/themes/Animated';

const SemiCirclePieChart = ({ 
  masteryPercentage = 50, 
  performancePercentage = 50, 
  chartId = "semi-circle-pie-chart" 
}) => {
  const chartRef = useRef(null);

  useEffect(() => {
    // Ensure the DOM element exists before creating the chart
    const chartElement = document.getElementById(chartId);
    if (!chartElement) {
      return;
    }

    // Create root element
    const root = am5.Root.new(chartId);

    // Set themes
    root.setThemes([
      am5themes_Animated.new(root)
    ]);

    // Create chart
    const chart = root.container.children.push(
      am5percent.PieChart.new(root, {
        startAngle: 180,
        endAngle: 360,
        layout: root.verticalLayout,
        innerRadius: am5.percent(50)
      })
    );

    // Create series
    const series = chart.series.push(
      am5percent.PieSeries.new(root, {
        valueField: "value",
        categoryField: "category",
        startAngle: 180,
        endAngle: 360,
        alignLabels: false
      })
    );

    // Configure series appearance
    series.slices.template.setAll({
      strokeWidth: 2,
      stroke: am5.color("#ffffff")
    });

    // Configure labels to show only percentages
    series.labels.template.setAll({
      textType: "circular",
      centerX: 0,
      centerY: 0,
      fontSize: "14px",
      fontWeight: "600",
      text: "{value}%"
    });

    // Set data with rounded values
    const data = [
      {
        category: "Mastery",
        value: Math.round(masteryPercentage),
        color: am5.color("#22c55e") // Green
      },
      {
        category: "Performance",
        value: Math.round(performancePercentage),
        color: am5.color("#3b82f6") // Blue
      }
    ];

    series.data.setAll(data);

    // Set colors for slices
    series.slices.template.adapters.add("fill", (fill, target) => {
      const dataItem = target.dataItem;
      if (dataItem) {
        return dataItem.dataContext.color;
      }
      return fill;
    });

    // Add legend
    const legend = chart.children.push(
      am5.Legend.new(root, {
        centerX: am5.percent(50),
        x: am5.percent(50),
        marginTop: 15,
        marginBottom: 15
      })
    );

    legend.data.setAll(series.dataItems);

    // Configure legend labels
    legend.labels.template.setAll({
      fontSize: "12px",
      fontWeight: "500"
    });

    // Custom formatter for legend labels to round values
    legend.labels.template.adapters.add("text", (text, target) => {
      const dataItem = target.dataItem;
      if (dataItem) {
        const category = dataItem.dataContext.category;
        const value = Math.round(dataItem.dataContext.value);
        return `${category} ${value}%`;
      }
      return text;
    });

    // // Add custom axis labels at the ends using the main container
    // // Wait for chart to be fully rendered before adding labels
    // setTimeout(() => {
    //   // Add Mastery label on the left
    //   chart.children.push(
    //     am5.Label.new(root, {
    //       text: "Mastery",
    //       fontSize: "14px",
    //       fontWeight: "700",
    //       fill: am5.color("#22c55e"),
    //       x: am5.percent(25),
    //       y: am5.percent(75),
    //       centerX: am5.percent(50),
    //       centerY: am5.percent(50)
    //     })
    //   );

    //   // Add Performance label on the right
    //   chart.children.push(
    //     am5.Label.new(root, {
    //       text: "Performance",
    //       fontSize: "14px",
    //       fontWeight: "700",
    //       fill: am5.color("#3b82f6"),
    //       x: am5.percent(74),
    //       y: am5.percent(75),
    //       centerX: am5.percent(50),
    //       centerY: am5.percent(50)
    //     })
    //   );
    // }, 100);

    // Store root for cleanup
    chartRef.current = root;

    // Cleanup function
    return () => {
      if (chartRef.current) {
        chartRef.current.dispose();
      }
    };
  }, [masteryPercentage, performancePercentage, chartId]);

  return (
    <div className="w-full h-80 flex flex-col items-center">
      <div id={chartId} className="w-full h-full"></div>
    </div>
  );
};

export default SemiCirclePieChart;
